import React, { useEffect } from "react";
import styles from "../assets/scss/pages.module.scss";
import WorldNewsSection from "sections/artYerkirPage/worldNewsSection/WorldNewsSection";
import InterviewsSection from "sections/artYerkirPage/interviewsSection/InterviewsSection";
import ArticlesSection from "sections/artYerkirPage/articlesSection/ArticlesSection";
import HistoryThroughFacesSection from "sections/artYerkirPage/historyThroughFacesSection/HistoryThroughFacesSection";
import StoryOfAtworkSection from "sections/artYerkirPage/storyOfAtworkSection/StoryOfAtworkSection";
import ArtInNumbersSection from "sections/artYerkirPage/artInNumbersSection/ArtInNumbersSection";
import GuideToArtSection from "sections/artYerkirPage/guideToArtSection/GuideToArtSection";
import ExpertsSection from "sections/artYerkirPage/expertsSection/ExpertsSection";
import AboutArtYerkirSection from "sections/artYerkirPage/aboutArtYerkirSection/AboutArtYerkirSection";

const ArtYerkirPage = () => {
  const scrollToSection = (selector) => {
    const element = document.querySelector(selector);
    if (!element) return;
    const y = element.getBoundingClientRect().top + window.scrollY;
    const headerHeight = document.querySelector("header")?.offsetHeight || 100;
    window.scroll({
      top: y - headerHeight,
      behavior: "smooth",
    });
  };

  const handleMenuItemClick = (item) => {
    const sectionMap = {
      worldNewsRef: ".worldNewsRef",
      interviewsRef: ".interviewsRef",
      articlesRef: ".articlesRef",
      historyThroughFacesRef: ".historyThroughFacesRef",
      storyOfAtworkRef: ".storyOfAtworkRef",
      artInNumbersRef: ".artInNumbersRef",
      guideToArtRef: ".guideToArtRef",
      expertsRef: ".expertsRef",
      aboutArtYerkirRef: ".aboutArtYerkirRef",
    };

    const selector = sectionMap[item];
    if (selector) {
      scrollToSection(selector);
    }
  };

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  return (
    <div className={styles.artYerkirPageContainer}>
      <div className="container">
        <div className={styles.artYerkirPageGrid}>
          <div className={styles.artYerkirPageSections}>
            <div className={"worldNewsRef"}>
              <WorldNewsSection />
            </div>
            <div className={"interviewsRef"}>
              <InterviewsSection />
            </div>
            <div className={"articlesRef"}>
              <ArticlesSection />
            </div>
            <div className={"historyThroughFacesRef"}>
              <HistoryThroughFacesSection />
            </div>
            <div className={"storyOfAtworkRef"}>
              <StoryOfAtworkSection />
            </div>
            <div className={"artInNumbersRef"}>
              <ArtInNumbersSection />
            </div>
            <div className={"guideToArtRef"}>
              <GuideToArtSection />
            </div>
            <div className={"expertsRef"}>
              <ExpertsSection />
            </div>
            <div className={"aboutArtYerkirRef"}>
              <AboutArtYerkirSection />
            </div>
          </div>
          <div className={styles.artYerkirPageNavigation}>
            <ul className="stickyArtYerkirSidebar">
              <li onClick={() => handleMenuItemClick("worldNewsRef")}>
                World News
              </li>
              <li onClick={() => handleMenuItemClick("interviewsRef")}>
                Interviews
              </li>
              <li onClick={() => handleMenuItemClick("articlesRef")}>
                Articles
              </li>
              <li onClick={() => handleMenuItemClick("historyThroughFacesRef")}>
                History Through Faces
              </li>
              <li onClick={() => handleMenuItemClick("storyOfAtworkRef")}>
                The story of an artwork
              </li>
              <li onClick={() => handleMenuItemClick("artInNumbersRef")}>
                Art In numbers
              </li>
              <li onClick={() => handleMenuItemClick("guideToArtRef")}>
                guide to art
              </li>
              <li onClick={() => handleMenuItemClick("expertsRef")}>experts</li>
              <li onClick={() => handleMenuItemClick("aboutArtYerkirRef")}>
                about art yerkir
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArtYerkirPage;
